import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SurveyLayout } from "./SurveyLayout";
import { SurveyRunner } from "./SurveyRunner";
import { PaywallSurveyOffer } from "./PaywallSurveyOffer";
import { useConsent } from "../../dashboard/hooks/useConsent";
import { skipOnboardingForSession } from "./RequireOnboarding";

export function OnboardingGatePage({ onLogout }) {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { grant } = useConsent();
  const [showPaywall, setShowPaywall] = useState(false);

  const handleComplete = async () => {
    try {
      await grant("research_participation", {
        consentTextVersion: "1.0",
        sourceContext: "onboarding",
      });
    } catch (_) {}
    setShowPaywall(true);
  };

  const goToDashboard = () => {
    navigate("/dashboard", { replace: true });
  };

  const handleAbandon = () => {
    skipOnboardingForSession();
    goToDashboard();
  };

  return (
    <>
      <SurveyLayout
        title={t("onboarding.welcome", "Welcome to GWBI")}
        subtitle={t(
          "onboarding.intro",
          "Help us understand the wine industry better. This quick profile survey takes about 90 seconds and helps tailor your experience."
        )}
        tagline={t("onboarding.tagline", "Shape the future of wine")}
      >
        <SurveyRunner
          code="onboarding_profile"
          sourceContext="onboarding"
          onComplete={handleComplete}
          onAbandon={handleAbandon}
          variant="dark"
        />
      </SurveyLayout>

      <PaywallSurveyOffer
        feature="full_access"
        isOpen={showPaywall}
        onClose={goToDashboard}
        onSubscribe={goToDashboard}
        onUnlock={goToDashboard}
        onDismiss={goToDashboard}
      />
    </>
  );
}
